import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { cancelChangeMonitoring } from '@api/manageNetworkElementConfigurations';

import { IWithUpdateId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_CANCEL_CHANGE_MONITORING } from '@constants/queryKeys';

interface IUseMutateChangeMonitoringCancelReturned {
	isLoadingCancelChangeMonitoring: boolean;
	cancelChange: UseMutateFunction<any, any, IWithUpdateId, any>;
}

const useMutateChangeMonitoringCancel = (
	onSuccess?: () => void,
): IUseMutateChangeMonitoringCancelReturned => {
	const {
		isLoading,
		mutate,
	} = useMutation<IWithUpdateId>({
		mutationKey: [NETWORK_ELEMENT_CANCEL_CHANGE_MONITORING],
		mutationFn: cancelChangeMonitoring,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess,
	});

	return {
		isLoadingCancelChangeMonitoring: isLoading,
		cancelChange: mutate,
	};
};

export default useMutateChangeMonitoringCancel;
